<template>
  <div class="kt-portlet">
    <div class="kt-portlet__body kt-portlet__body--fit">
      <div
        class="kt-grid kt-wizard-v2 kt-wizard-v2--white"
        id="kt_wizard_v2"
        data-ktwizard-state="step-first"
      >
        <div class="kt-grid__item kt-wizard-v2__aside py-5">
          <!--begin: Form Wizard Nav -->
          <div class="kt-wizard-v2__nav">
            <div
              class="kt-wizard-v2__nav-items kt-wizard-v2__nav-items--clickable"
            >
              <!--doc: Replace A tag with SPAN tag to disable the step link click -->
              <div
                class="kt-wizard-v2__nav-item"
                data-ktwizard-type="step"
                data-ktwizard-state="current"
                v-for="setting in settingsList"
                :key="setting.title"
              >
                <div class="kt-wizard-v2__nav-body">
                  <div class="kt-wizard-v2__nav-icon">
                    <i :class="setting.icon"></i>
                  </div>
                  <div class="kt-wizard-v2__nav-label">
                    <div class="kt-wizard-v2__nav-label-title">
                      {{ setting.title }}
                    </div>
                    <div class="kt-wizard-v2__nav-label-desc">
                      {{ setting.description }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--end: Form Wizard Nav -->
        </div>
        <div class="kt-grid__item kt-grid__item--fluid kt-wizard-v2__wrapper">
          <!--begin: Form Wizard Form-->
          <ManageCurrency />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import KTUtil from "@/assets/js/util";
import KTWizard from "@/assets/js/wizard";
import ManageCurrency from "@/views/pages/admin/settings/ManageCurrency.vue";

export default {
  components: {
    ManageCurrency
  },
  data() {
    return {
      settingsList: [
        {
          title: "Currency",
          description: "Manage Payment Currency",
          icon: "flaticon-coins"
        }
      ]
    };
  },
  methods: {
    setBreadCrumb(currentStep) {
      let currentPage = this.settingsList[currentStep - 1].title;

      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Admin Settings" },
        { title: currentPage }
      ]);
    }
  },
  mounted() {
    this.setBreadCrumb(1);
    const wizard = new KTWizard("kt_wizard_v2", {
      startStep: 1, // initial active step number
      clickableSteps: true // allow step clicking
    });

    const vm = this;

    wizard.on("change", function(obj) {
      vm.setBreadCrumb(obj.currentStep);

      setTimeout(function() {
        KTUtil.scrollTop();
      }, 500);
    });
  }
};
</script>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-2.scss";
</style>

<style scoped>
.kt-form {
  padding: 0 !important;
}
</style>
